import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Eksterne leveringer',
  fields: {
    pickup: 'Afhentning',
    dropoff: 'Aflevering',
    status: 'Status',
    estimated_time: 'Estimeret tid',
    actual_time: 'Faktisk tid',
    actions: 'Handlinger',
    time: 'Tid',
    pickup_estimate: 'Estimeret afhentning',
    dropoff_estimate: 'Estimeret aflevering',
  },
  labels: {
    pickup: 'Afhentning',
    dropoff: 'Aflevering',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Afventer chauffør',
    [DeliveryStatus.RunnerAssigned]: 'Chauffør tildelt',
    [DeliveryStatus.OnRoutePickup]: 'På vej til afhentning',
    [DeliveryStatus.ArrivedPickup]: 'Ankommet til afhentning',
    [DeliveryStatus.PickedUp]: 'Afhentet',
    [DeliveryStatus.OnRouteDropoff]: 'På vej til aflevering',
    [DeliveryStatus.ArrivedDropoff]: 'Ankommet til aflevering',
    [DeliveryStatus.Completed]: 'Gennemført',
    [DeliveryStatus.Cancelled]: 'Annulleret',
  },
  buttons: {
    actions: 'Handlinger',
    open_tracking_url: 'Spor levering',
    show_order_details: 'Vis ordredetaljer',
    call_restaurant: 'Ring til restaurant',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
